import React from 'react';
import '../css/contactCard.css';
import RoundButton from '../../../button/round-button/ts/roundButton';

interface ContactCardProps {
  title: string;
  description: string;
  buttonText: string;
  onButtonClick?: () => void;
  className?: string;
}

const ContactCard: React.FC<ContactCardProps> = ({
  title,
  description,
  buttonText,
  onButtonClick,
  className
}) => {
  return (
    <div className={`scl--web-component-contact-card-container ${className || ''}`}>
      <div className="scl--web-component-contact-card-inner">
        <div className="scl--web-component-contact-rectangle-3" />
        <div className="scl--web-component-contact-rectangle-2" />
        <div className="scl--web-component-contact-card-content-wrapper">
          <div className="scl--web-component-contact-text-container">
            <h3 className="scl--web-component-contact-card-title">{title}</h3>
            <p className="scl--web-component-contact-card-description">{description}</p>
          </div>
          <RoundButton
            text={buttonText}
            onClick={onButtonClick}
            showIcon={false}
            className="scl--web-component-contact-styled-button"
          />
        </div>
      </div>
    </div>
  );
};

export default ContactCard;
